<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>{{subtitle}}</strong> 

          </div>
          <b-row style="margin-top:-5%">
           
          <b-col md="12" >
        
            <div class="tab-panel" >
              
              <b-row class="mt-2 mb-2"> 


            <b-col sm="3" style="padding-bottom: 3%">
                        <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields'   enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>

 

               </b-col>
                <b-col sm="3">
                                       <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select vendor" v-model="value3" :dataSource='vendoroptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"     :fields='agentfields'   enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>




                </b-col>

                <b-col sm="3">
                  <div id='container' style="margin:50px auto 0; width:250px;">
                    <br>
                  <b-form-group label-cols-sm="3" label="Search" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                </b-col>






             <!--    <b-col md="3" class="my-1 ">
                  <b-form-group label-cols-sm="3" label="Search" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
               <!--   <b-col md="3" class="my-1">
                   <b-form-group label="Delivery Agent"  :label-cols="4" >
                           <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                                  <option :value="selected"  >--Select--</option>
                                  <option v-for="agent in agentmaster"  v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}</option>
                             </b-form-select>
                              
                                     
                          </b-form-group> 

                </b-col>  -->


             <!--                <b-col sm="3">
              <b-form-group label="Select Vender"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="vendorid" name="vendorid" >
                        <option :value="selected"  >--Select--</option>
                        <option v-for="vendor in vendorlist"  v-bind:value="vendor.vendor_name">{{vendor.vendor_name}} </option>
                   </b-form-select>
                 </b-form-group>
               </b-col> -->

               <!-- <b-row>

               <b-col sm="4">
                <b-form-group label="From Date:"  :label-cols="3" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="3" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col> 


               <b-col md="12" class="my-1 ">
                  <b-form-group label-cols-sm="3" label="Search" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>   -->           
                
                <b-col md="12" class="my-1 text-right">
                    <b-button type="submit" size="md" variant="primary" @click="getdashboardshipmentlist(pageNum)"> Search</b-button> &nbsp;&nbsp;&nbsp;
                     <b-button type="submit" size="md" variant="primary"  @click="clear()"> clear</b-button>
                     <b-button v-if="this.totalRows > 0" variant="primary" size="md" style="margin-left:10px;" @click="downloadCSV">Download </b-button>  
                </b-col>
                 
                 <b-col sm="12" class="text-right">
                         <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
                        </b-col>           
              
            </b-row>
            <div id="overlay" >
             <div class="loader"></div>
           </div>

              <b-table show-empty stacked="md" :items="items"   @sort-changed="sortChanged" :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" :bordered="bordered"    :outlined="outlined" :busy="isBusy" >
                      <template slot="userinfo" slot-scope="row">
                             {{ row.item.deliveryagentfirstname}} {{ row.item.deliveryagentlastname}}
                      </template> 
                      <template slot="actions" slot-scope="row">
                          <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                                  View
                          </b-button>
                      </template>
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     
                  </b-table> 


              <!-- <shipmentstatuslist style="width:70%;"></shipmentstatuslist>
 -->

            </div>

          
           
             </b-col>
          </b-row> 
          <b-col md="12" class="my-1" >
            <paginate 
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </b-col>   
        </b-card>
       
      </b-col>
    </b-row> 




  </div>   


</template>
<script>
// import CONSTANTS from "@/utils/constants";
// import Utils from "@/utils";
// //import shipmentstatuslist from './shipmentstatuslist.vue'


// export default {
//   data: function() {
//     return {
//       activeTab: 0,
//       //shipmentstatuslist,
//       subtitle:'',
      
//     };
//   },
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      assigned:[],
      items:[],
      isBusy: false,
      fields: [
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'userinfo', label: 'Rider Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Rider Mobile Number', sortable: true},               
          { key: 'lastmodifieddate', label: 'Date', sortable: true },
           //{ key: 'nprreason', label: 'NPR Reson', sortable: true },
           //{  key: 'ndrreason', label: 'NDR Reson' },
      ],
      fields1: [
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'userinfo', label: 'Rider Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Rider Mobile Number', sortable: true},               
          { key: 'lastmodifieddate', label: 'Date', sortable: true },
           { key: 'nprreason', label: 'NPR Reson', sortable: true },
           ],
          
      fields2: [
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'userinfo', label: 'Rider Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Rider Mobile Number', sortable: true},               
          { key: 'lastmodifieddate', label: 'Date', sortable: true },
           
           {  key: 'ndrreason', label: 'NDR Reson' },
      ],
      outlined: true,
      totalRows: 0,
      bordered: true,
       selected:'',
        deliveryagentid:'',
      agentmaster: [],
        options: [],
      vendoroptions:[],
      currentPage: 1,
      perPage:  20,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
       agentfields: { text: 'name', value: 'id' },
        showSelectAll : true,
      // selectDateFrom: new Date(),
      // selectDateTo: new Date(),
       vendorid:'',
      value2:[],
      value3:[],
       subtitle:'',
       vendorlist:[],
      filter: null,
      infoModal: {
          id: 'info-modal',
          title: '',
          content: '',
          data:''
      },
      noofpages:'',
        pageNum:1,
        listingpageno:1,
        sortBy : '',
    }
  },

   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function() {

    this.id = this.$route.params.id;
    
    this.titlearr={
      "PL_Pickup_Assigned" : "3PL Hub Pickup Assigned",
      "PL_Pickup_Not_Assigned" : "3PL Pickup Not Assigned",
      "PL_Pickup_INTransit" : "3PL Pickup In Transit",
      "PL_Pick_Cancelled" : "3PL Pickup Cancelled",
      "PL_Hub_Handover_Done" : "3PL Hub Handover Done",
      "pickup_by_3pl" : "Pickup By 3PL",


      "Vendor_Pickup_Assigned" : "P2P Hub Pickup Assigned",
      "Vendor_Pickup_Not_Assigned" : "P2P Hub Pickup Not Assigned",
      "Vendor_Pickup_INTransit" : "P2P Hub Pickup In Transit",
      "Vendor_Pick_Cancelled" : "P2P Hub Pickup Cancelled",
      "Vendor_Handoverdone_to_P2P_Hub" : "P2P  Hub Handover Done",

      "WH_Pickup_Assigned" : "WH Pickup Assigned",
      "WH_Pickup_Not_Assigned" : "WH Pickup  Not Assigned",
       "WH_Pickup_OFD" : "WH Pickup OFD",
      "WH_Pick_Cancelled_NPR" : "WH Pickup Cancelled NPR",
      "WH_NDR" : "WH NDR",
      "WH_Delivered_at_Customer" : "WH Delivered At Customer ",
      "WH_RTO" : "WH RTO  ",
      
      "Vendor_Lastmile_Pickup_Assigned" : "Vendor Pickup Assigned  ",
      "Vendor_Lastmile_Pickup_Not_Assigned" : "Vendor Pickup  Not Assigned",
       "Vendor_Lastmile_Pickup_OFD" : "Vendor Pickup OFD",
      "Vendor_Lastmile_Pick_Cancelled_NPR" : "Vendor Pickup Cancelled NPR",
      "Vendor_Lastmile_NDR" : "Vendor NDR",
      "Vendor_Lastmile_Delivered_at_Customer" : "Vendor Delivered At Customer",
      "Vendor_Lastmile_RTO" : "Vendor RTO  ",
      

      "Reverse_Pickup_Assigned" : "Reverse Pickup Assigned",
      "Reverse_pickup_Not_Assigned" : "Reverse Pickup Not Assigned",
      "Reverse_Picked_UP" : "Reverse Picked UP",
      "Reverse_NPR" : "Reverse NPR",
      "Reverse_RTO" : "Reverse RTO",
      
    };

    // Load Delivery Agent List
    this.displaydeliveryagent();
     this.vendor();

    this.getdashboardshipmentlist(this.pageNum);
      
     // console.log(this.titlearr); 

     //this.subtitle=this.id;
    this.subtitle=this.titlearr[this.id];
    // console.log(this.subtitle);

     
                if(this.subtitle=="3PL Pickup Cancelled"||this.subtitle=="P2P Hub Pickup Cancelled"||this.subtitle=="WH Pickup Cancelled NPR"||this.subtitle=="Vendor Pickup Cancelled NPR"||this.subtitle=="Reverse NPR")
                {
                     this.fields=this.fields1
                 }

                 else

                if(this.subtitle=="WH NDR"||this.subtitle=="Vendor NDR")
                {
             this.fields=this.fields2
              }
              else
              {
                this.fields=this.fields 
              }
             
  },
  methods: {
    sortChanged: function (ctx) { 
      this.sortBy = ctx.sortBy 
      console.log("gfgggggggggggggggggg",this.sortBy)
      this.getdashboardshipmentlist(this.pageNum);
    },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    vendor: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getvendorlist`)
        .then((result) => {
          this.vendorlist  = result.body
                 for(var i = 0; i < this.vendorlist.length; i++) {
            var vendor2 = {
        name: this.vendorlist[i].vendor_name,
         id: this.vendorlist[i].vendor_name,
       
      }
 this.vendoroptions.push(vendor2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    downloadCSV: function() {
    
    
document.getElementById("overlay").style.display = "block";
 var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
          
         
        var vendorarr=[];
          vendorarr=this.value3;
          var deliveryagentid = deliveryagentidarr;
           var vendorid = vendorarr;
      //agentmaster
     // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
     //  var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // let userData = localStorage.getItem('userData');
      // let userInfo = JSON.parse(userData);
      // let pincode=JSON.stringify(userInfo.pickuplocationpincode);
      let obj = {
        // pickuplocationpincode: pincode,
        keyword:  this.id,
        deliveryagentid:deliveryagentid,
        vendor:vendorid,
        sysusermasterid:`${userInfo.sysusermasterid}`, 
        hub_id:`${userInfo.pickuplocationmasterid}`,
             // page_no:1,

      }
     
    
  // dashboardwarrantyshipmentlistcsv_advanced
   this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/dashboardCrossCountryShipmentListcsv_advanced`,obj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
       }
       else
       {
        alert("Can not Download");
       }
        });
        
    },




displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
     
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentfirstname+"  "+this.agentmaster[i].deliveryagentlastname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },


    //   displaydeliveryagent: function() {
    //   var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    //   //agentmaster
    //   const deliveryagent = {
    //     deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
    //     isactive: '1'
    //   }
    //   this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`, deliveryagent)
    //     .then((result) => {
    //       this.agentmaster = result.body
    //     })
    //     .catch((ex) => {
    //       console.log('error', ex)
    //     })
    // },
 // formatDate: function(date) {
 //      var d = new Date(date),
 //        month = "" + (d.getMonth() + 1),
 //        day = "" + d.getDate(),
 //        year = d.getFullYear();
 //      if (month.length < 2) month = "0" + month;
 //      if (day.length < 2) day = "0" + day;
 //      return [year, month, day].join("-");
 //    },
 clear: function() {
   // this.searching="";
   this.filter=null;
   this.value2=[];
   this.value3=[];
   this.showSelectAll=false;
   this.getdashboardshipmentlist(this.pageNum);
      
    },

    clickCallback (pageNum){
          this.listingpageno = pageNum;
        console.log("pageNum",this.listingpageno)
           this.getdashboardshipmentlist(pageNum);
      },

    getdashboardshipmentlist(pageNo){
var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //alert("A");
      this.isBusy = true;
       var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
          
         
        var vendorarr=[];
          vendorarr=this.value3;
          var deliveryagentid = deliveryagentidarr;
           var vendorid = vendorarr;
      //agentmaster
     // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
     //  var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // let userData = localStorage.getItem('userData');
      // let userInfo = JSON.parse(userData);
      // let pincode=JSON.stringify(userInfo.pickuplocationpincode);
      let obj = {
        // pickuplocationpincode: pincode,
        keyword:  this.id,
        deliveryagentid:deliveryagentid,
        vendor:vendorid,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        page_no:`${pageNo}`,
        order_by : this.sortBy,
         // fromdate:`${fromdate}`, 
         //  todate:`${formatdateto}`,

      }
    this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/dashboardCrossCountryShipmentList`,obj)
            .then(result => {
              // console.log(result.body);
                this.isBusy = !this.isBusy;
                if(result.body.returnmsg =="Successful"){
                  // console.log("result.body.returnvalue",result.body.returnvalue);
                  //this.assigned = result.body.returnvalue;
                 // this.items  = result.body.returnvalue;
                  //this.totalRows = result.body.returnvalue.length
                   
                  this.items =result.body.returnvalue;
                  this.totalRows = result.body.returnvalue[0].totalcount;
                  this.noofpages=parseInt(this.totalRows)/20;
                 this.noofpages=Math.ceil( this.noofpages);
                }else {
                 this.items  = [];
                 this.totalRows = 0
                }
            }).catch(ex => {
              console.log('error', ex)
            })
      }



  }
};
</script>
